import React from 'react'
import { useDebounce } from 'use-debounce'
import { Embroidery, EmbroideryKey, EmbroideryObjects, PartialAction } from 'src/types'

export const SET_EMBROIDERIES = 'setEmbroideries'
const embroideriesReducer = (embroideries: Embroidery[], newEmbroideries: Embroidery, i: number): Embroidery[] => {
  return embroideries.reduce((a: Embroidery[], c) => {
    if (c.id === i) a.push(newEmbroideries)
    if (c.id !== i) a.push(c)
    return a
  }, [])
}

interface ObjectKey {
  typeFace: string
  position: string
  color: string
  shadowColor: string
  edgeColor: string
}

const updateEmbroideries = (
  embroideries: Embroidery[],
  objects: EmbroideryObjects,
  selected: string,
  type: EmbroideryKey,
  i: number
): Embroidery[] => {
  const objectKey = type as keyof ObjectKey
  const newEmbroideries = {
    ...embroideries[i],
    [type]: objects[objectKey].filter((prev) => prev.value === selected)[0]
  }
  return embroideriesReducer(embroideries, newEmbroideries, i)
}

export const embroideriesDispatcher = (
  dispatch: React.Dispatch<PartialAction>,
  embroideries: Embroidery[],
  selected: string,
  objects: EmbroideryObjects,
  key: EmbroideryKey,
  i?: number | undefined
): void => {
  if (i === undefined) return
  dispatch({
    type: SET_EMBROIDERIES,
    embroideries: updateEmbroideries(embroideries, objects, selected, key, i)
  })
}

export const useEmbroideryContent = (
  dispatch: (value: PartialAction) => void,
  embroideries: Embroidery[]
): ((content: string, i: number) => void) => {
  const [content, setContent] = React.useState('')
  const [contentNum, setContentNum] = React.useState(0)
  const [delayedValue] = useDebounce(content, 10)
  const handleContentAndNum = (content: string, i: number) => {
    setContent(content)
    setContentNum(i)
  }

  // テキストの遅延更新処理ここから
  const updateEmbroContent = (delayedValue: string, i: number) => {
    const newEmbroideries = { ...embroideries[i], content: delayedValue }
    return embroideriesReducer(embroideries, newEmbroideries, i)
  }
  React.useEffect(() => {
    dispatch({ type: SET_EMBROIDERIES, embroideries: updateEmbroContent(delayedValue, contentNum) })
  }, [delayedValue])
  // テキストの遅延更新処理ここまで
  return handleContentAndNum
}

// n-1番目までのembroideryで指定された刺繍位置のvalueリストを返す
export const embroideryPositionListGenerator = (embroideries: Embroidery[], overAllIndex: number) =>
  embroideries
    .map((e, i) => {
      if (i < overAllIndex) {
        return e.position.value
      }
    })
    .filter(Boolean)

export const embroideryPositionFilter = (
  positionObjects: { label: string; value: string }[],
  selectedPosition: string[]
): {
  label: string
  value: string
}[] => positionObjects.filter((p) => !selectedPosition.includes(p.value))
